(function() {
    'use strict';
    angular.module('wamasysApp').factory('EventConfigurationAssistant', EventConfigurationAssistant);
    EventConfigurationAssistant.$inject = ['$http', 'Principal', 'AssistantPanelService', 'CommunicationAutomationConf', '$rootScope'];

    function EventConfigurationAssistant($http, Principal, AssistantPanelService, CommunicationAutomationConf, $rootScope) {
        return {open: open, canUse: canUse};

        function canUse(mode) {
            return Principal.identity().then(function(account) {
                var roles = (account && account.authorities) || [];
                var admin = roles.indexOf('ROLE_ADMIN') !== -1 || roles.indexOf('ROLE_SUPER_ADMIN') !== -1;
                return !!account && (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                    && (admin || roles.indexOf('ROLE_AI_ASSISTANT') !== -1)
                    && (admin || mode === 'DASHBOARD' && (roles.indexOf('ROLE_EVT_EDIT') !== -1 || roles.indexOf('ROLE_EVT_READ_ONLY') !== -1));
            });
        }

        function open(mode, onCreated) {
            var latestMessage;
            var creating = false;
            var baseUrl = 'api/event-configuration-assistant/' + mode;
            var context = {
                contextType: 'EVENT_CONFIGURATION', entityId: mode,
                title: mode === 'DASHBOARD' ? 'Assistant — tableaux de bord' : 'Assistant — dictionnaire des événements',
                subtitle: 'Décrivez votre besoin, puis validez la proposition.',
                promptPlaceholder: mode === 'DASHBOARD' ? 'Quels événements et indicateurs souhaitez-vous suivre ?' : 'Quelles informations souhaitez-vous recueillir, et pour quel événement ?',
                supportsActionProposal: false, supportsDataScopes: false,
                defaultSelectedDataScopes: [], defaultSelectedInstructionDomains: [],
                defaultCreativityLevel: 'PRECISE',
                adapter: {
                    getErrorMessage: function(error) {
                        return (error.data && error.data.message) || (error.headers && error.headers('X-wamasysApp-detail'))
                            || 'L’assistant n’a pas pu préparer la proposition. Réessayez dans quelques instants.';
                    },
                    getUsage: function(success, error) { CommunicationAutomationConf.getAssistantUsage(success, error); },
                    chat: function(payload, success, error) {
                        if (creating) {
                            error({data: {message: 'Attendez la fin de la création avant de poursuivre la discussion.'}});
                            return;
                        }
                        // Keep the JSON in conversational history so a follow-up can refine the exact proposal.
                        if (latestMessage && latestMessage.configurationJson) {
                            for (var index = payload.messages.length - 1; index >= 0; index--) {
                                if (payload.messages[index].role === 'assistant') {
                                    payload.messages[index].content += '\nProposition JSON :\n' + latestMessage.configurationJson
                                        + (latestMessage.configurationCreated ? '\nCette proposition a déjà été créée.' : '');
                                    break;
                                }
                            }
                        }
                        // A later request supersedes previous proposals, preventing accidental stale writes.
                        if (latestMessage) { latestMessage.configurationSuperseded = true; }
                        $http.post(baseUrl + '/chat', payload).then(function(response) { success(response.data); }, error);
                    },
                    applyAssistantResponse: function(result, message) {
                        latestMessage = message;
                        var raw = (result.suggestedFieldValues || {}).template;
                        if (!raw || result.awaitingUserInput) { return; }
                        try {
                            message.configurationProposal = angular.fromJson(raw);
                            message.configurationJson = angular.toJson(message.configurationProposal, true);
                            message.configurationButton = mode === 'DASHBOARD' ? 'Créer ce tableau de bord' : 'Créer les champs et appliquer les ajouts';
                            message.confirmConfiguration = function() { create(message); };
                        } catch (error) {
                            message.configurationError = 'La proposition JSON est invalide. Demandez à l’assistant de la corriger.';
                        }
                    }
                }
            };
            canUse(mode).then(function(allowed) {
                if (!allowed) { return; }
                AssistantPanelService.open(context);
                // Reopening the same discussion keeps its proposals and attaches the current list refresh callback.
                angular.forEach(AssistantPanelService.state.messages, function(message) {
                    if (message.role === 'assistant') { latestMessage = message; }
                    if (message.configurationProposal) { message.confirmConfiguration = function() { create(message); }; }
                });
            });

            function create(message) {
                if (creating || message.configurationCreated || message.configurationSuperseded || AssistantPanelService.state.isSending) { return; }
                creating = true;
                message.configurationCreating = true;
                message.configurationError = null;
                // Only this user gesture writes. Receiving an assistant response never calls this endpoint.
                $http.post(baseUrl + '/create', message.configurationProposal).then(function() {
                    message.configurationCreated = true;
                    if (mode === 'DASHBOARD') { $rootScope.$broadcast('wamasysApp:eventDashboardUpdate'); }
                    AssistantPanelService.invalidateConversationContext();
                    if (onCreated) { onCreated(); }
                }, function(error) {
                    message.configurationError = (error.data && error.data.message) || (error.headers && error.headers('X-wamasysApp-detail'))
                        || 'La création a échoué. Vérifiez la configuration avant de réessayer.';
                }).finally(function() {
                    creating = false;
                    message.configurationCreating = false;
                });
            }
        }
    }
})();
